import React from "react";
import { Reveal } from "./Reveal";

export default function Manifesto() {
  return (
    <section className="manifesto" data-testid="manifesto">
      <div className="wrap">
        <Reveal>
          <p className="manifesto__line">
            Do not chase the answer. Route the decision to the person entitled to make it —
            with only the evidence they need.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="manifesto__sub">
            A dashboard can show a problem. KATLAS helps the right people resolve it.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
